import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../dishFullInfoState/dishFullInfoContext';
import TranslationsTab from './components/TranslationsTab/TranslationsTab';
import AdditionallyTab from './components/AdditionallyTab/AdditionallyTab';
import MainInfoTab from './components/MainInfoTab/MainInfoTab';

const Tabs: React.FC = () => {
	const { dishFullInfoVisibleForm } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	const getTab = () => {
		switch (dishFullInfoVisibleForm) {
			case 'mainForm':
				return <MainInfoTab />;
			case 'additionallyForm':
				return <AdditionallyTab />;
			case 'translationsForm':
				return <TranslationsTab />;
			default:
				return null;
		}
	};

	return <div data-test="Tabs">{getTab()}</div>;
};

export default Tabs;
